import type { LoginOutcome, SiteChoiceOption } from "@lumora/bridge";

export type SignInResult =
  | { kind: "signedIn"; site?: string }
  | { kind: "choose"; sites: SiteChoiceOption[] };

export interface SignInTransport {
  loginWithSiteChoice(input: { site?: string; email: string; password: string }): Promise<LoginOutcome>;
}

/**
 * One login attempt. `site` is set only when re-submitting from the "Choose a site" step.
 * The password is passed through, never stored or logged here.
 */
export async function attemptSignIn(
  client: SignInTransport,
  input: { email: string; password: string; site?: string },
): Promise<SignInResult> {
  const res = await client.loginWithSiteChoice({
    email: input.email,
    password: input.password,
    ...(input.site ? { site: input.site } : {}),
  });
  if ("requiresSiteChoice" in res) {
    return { kind: "choose", sites: res.sites };
  }
  return res.site ? { kind: "signedIn", site: res.site } : { kind: "signedIn" };
}
